import { type SxProps, Typography } from "@mui/material";
import type { FC } from "react";

type Props = {
	text?: string;
	maxChars?: number;
	sxProps?: SxProps;
	render?: "always" | "whenTextExists";
};

export const maxCharsDefault = 1500;

export const CharCounter: FC<Props> = ({ maxChars = maxCharsDefault, text, sxProps, render = "whenTextExists" }) => {
	return render === "always" || text?.length ? (
		<Typography
			sx={{
				fontSize: 10,
				color: maxChars && !!text ? (text.length >= 0.9 * maxChars ? "red" : "grey") : "grey",
				fontWeight: 500,
				opacity: render === "always" && !text ? 0 : 1,
				...sxProps,
			}}
		>
			{text ? text.length : 0}/{maxChars}
		</Typography>
	) : null;
};
